import { API, authClient } from "../index";

// Crea el tiper anónimo de la cookie (el backend solo guarda el idioma)
export const postTiper = async (tiper) => {
  return authClient().post(`${API}/tiper`, tiper);
};

// Identificar tiper por email desde la pantalla de éxito:
// fusiona el anónimo de la cookie con el que tenga ese email, guarda el
// consentimiento y enlaza la propina. Devuelve { tiperId, merged, movedTips }.
export const identifyTiper = async (payload) => {
  return authClient().post(`${API}/tiper/identify`, payload);
};

// Perfil de pago (pantalla de pago): { identified, saveCardConsent, canOneTap,
// paymentMethods }. Las tarjetas solo llegan con la cookie firmada tiper.pay.
export const getTiperPaymentProfile = async (payload) => {
  return authClient().post(`${API}/tiper/payment-profile`, payload);
};
